import isNaN from 'lodash/isNaN';
import isNil from 'lodash/isNil';

/**
 * Ensure that the list used in the STR Reg Client repo is up-to-date with this list in all environments.
 * https://github.com/deckardtech/str-registration-generic-client/blob/develop/scripts/stats-src/types/types-portal/reporting-history-types.ts
 */
export type TSupportedLocales = 
  | 'en-US'
  | 'en-AU'
  | 'en-GB'
  | 'en-CA';

const LOCALE_CURRENCY_MAP: Record<TSupportedLocales, string> = {
  'en-US': 'USD',
  'en-AU': 'AUD',
  'en-GB': 'EUR',
  'en-CA': 'CAD',
};

export function convertToCurrencyFormat(
  value: string | number | undefined,
  locale: TSupportedLocales = 'en-US',
) {
  if (isNil(value)) return value;

  const number = Number(value);
  if (isNaN(number)) return value;

  try {
    const currencyFormattedValue = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: LOCALE_CURRENCY_MAP[locale],
      currencyDisplay: 'narrowSymbol',
    }).format(number);

    return currencyFormattedValue;
  } catch (e) {
    return number.toFixed(2);
  }
}